export const INSTALLATION_INTENT = "Installation and setup";
